import React, { useState, useEffect, useRef } from "react";
import "./Tasty.css";

const Tasty = () => {
	const [imageOne, setImageOne] = useState(500);
	const [imagetwo, setImagetwo] = useState(500);
	const [imagethree, setImagethree] = useState(500);
	const img1Ref = useRef(null);
	const img2Ref = useRef(null);
	const img3Ref = useRef(null);
	useEffect(() => {
		const handleScroll = () => {
			const el = document.querySelector(".tastyDiv");
			const textEl = document.querySelector(".tastyText");

			if (
				!el ||
				!textEl ||
				!img1Ref.current ||
				!img2Ref.current ||
				!img3Ref.current
			)
				return;

			const screenBottom = window.innerHeight;
			const elPos = el.getBoundingClientRect().top;

			if (elPos < screenBottom && elPos + 150 > 0) {
				textEl.style.visibility = "visible";
				textEl.style.opacity = "1";
				textEl.style.transform = "translateX(0)";
			} else {
				textEl.style.visibility = "hidden";
				textEl.style.opacity = "0";
				textEl.style.transform = "translateX(-300px)";
			}

			const updateImage = (rect, setter) => {
				setter(rect.bottom - 50 < screenBottom ? 0 : 500);
			};

			updateImage(img1Ref.current.getBoundingClientRect(), setImageOne);
			updateImage(img2Ref.current.getBoundingClientRect(), setImagetwo);
			updateImage(img3Ref.current.getBoundingClientRect(), setImagethree);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className='tasty'>
			<div className='tastyText'>
				<h2>Hautnah, leise und spektakulär</h2>
				{/* <h3>Front-End Developer • Created with React</h3> */}
				<p>
					Erlebe die grenzenlose Freiheit, während du sanft durch die Lüfte
					gleitest. Lass den Alltag hinter dir und genieße das unbeschreibliche
					Gefühl, wie ein Vogel durch die Luft zu schweben. Diese Rundflüge
					bieten dir ein unvergleichliches Abenteuer und eine neue Perspektive
					auf die Welt unter dir.
				</p>
				{/* <a
          href="https://the-tasty-app.netlify.app/"
          target="_blank"
          rel="noreferrer"
          className="tasty-flip"
          data-back="Tasty App"
          data-front="Show Me"
        >
        </a> */}
				<ul>
					<li>
						Langsame Fluggeschwindigkeit für intensives Erlebnis (30–40 km/h)
					</li>
					<li>Perfekt für Fotografie & Videos</li>
					<li>Persönliche Betreuung vor und während des Fluges</li>
					<li>Sicher & entspannt für alle Altersklassen</li>
				</ul>
			</div>
			<img
				ref={img1Ref}
				style={{ transform: `translateX(${imageOne}%)` }}
				src='./img/bilder/tasty3.png'
				alt=''
				className='image1'
			/>
			<img
				ref={img2Ref}
				style={{ transform: `translateX(${imagetwo}%)` }}
				src='./img/bilder/tasty2.png'
				alt=''
				className='image2'
			/>
			<img
				ref={img3Ref}
				style={{ transform: `translateX(${imagethree}%)` }}
				src='./img/bilder/tasty.png'
				alt=''
				className='image3'
			/>
		</div>
	);
};

export default Tasty;
